module.exports = __webpack_public_path__ + "static/media/Step 8-Save_Current_Project.77617bdf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial-images/Step 8-Save_Current_Project.gif
// module id = 3049
// module chunks = 0